import { loadState, saveState } from '../../utils/storage'

const NAME = 'FirstLaunch'

export const isFirstLaunch = () => loadState(false, NAME, false)
export const saveFirstLaunch = () => saveState(true, false, NAME)